

export class MaintenanceTypeUpdateInput implements IMaintenanceTypeUpdateInput {
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId!: number;
    /** The maintenance type name with 255 character limit */
    maintenanceTypeName!: string;

    constructor(data?: IMaintenanceTypeUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maintenanceTypeId = _data["maintenanceTypeId"];
            this.maintenanceTypeName = _data["maintenanceTypeName"];
        }
    }

    static fromJS(data: any): MaintenanceTypeUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceTypeUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenanceTypeId"] = this.maintenanceTypeId;
        data["maintenanceTypeName"] = this.maintenanceTypeName;
        return data; 
    }
}

export interface IMaintenanceTypeUpdateInput {
    /** The auto-generated id of the maintenance type master */
    maintenanceTypeId: number;
    /** The maintenance type name with 255 character limit */
    maintenanceTypeName: string;
}

